import store from '@/store'
import CommercialErrorReport from '@/pages/commercialerrorreport';

export default [
  {
    path: '/',
    component: CommercialErrorReport,
    name: 'CommercialErrorReport'
  },
  {
    path: '/login',
    name: 'Login',
    beforeEnter(){
      location.href = store.getters.webapp_config.url_to_mypages + '/#/logga-in?logout'
    }
  }
]
